import { Controller } from "@hotwired/stimulus"

// Копирование значения в буфер обмена.
//
// Заменяет вызов несуществовавшей глобальной функции copyToClipboard (находка 7):
// кнопка на карточке клиента звала её через onclick, функции в проекте не было,
// и нажатие молча не делало ничего.
export default class extends Controller {
  static values = { text: String }
  static targets = ["button"]

  async copy(event) {
    event.preventDefault()

    try {
      await navigator.clipboard.writeText(this.textValue)
      this.confirm()
    } catch {
      // Clipboard API недоступен без https (кроме localhost) и в старых браузерах —
      // тогда показываем значение, чтобы его можно было выделить руками.
      window.prompt("Скопируйте вручную:", this.textValue)
    }
  }

  confirm() {
    const button = this.hasButtonTarget ? this.buttonTarget : this.element
    const initial = button.getAttribute("title")

    button.classList.add("btn-success")
    button.setAttribute("title", "Скопировано")

    setTimeout(() => {
      button.classList.remove("btn-success")
      button.setAttribute("title", initial || "Скопировать")
    }, 1200)
  }
}
